import React, { useState } from 'react';

interface DatePickerProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
}

const DatePicker: React.FC<DatePickerProps> = ({ value, onChange }) => {
  const [dateString, setDateString] = useState(value ? value.toISOString().split('T')[0] : '');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setDateString(newValue);
    onChange(newValue ? new Date(newValue) : null);
  };

  return (
    <input type="date" value={dateString} onChange={handleChange} />
  );
};

export default DatePicker;
